export default "__VITE_ASSET__GsdsZnhl__";